import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import { TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS } from "../services/constants";
import { showToastNotification } from "../reducers/toastSlice";
import { t, untranslated } from "@i18n";
import type {
  AddProjectRoleRequest,
  AddProjectRoleResponse,
  DeleteProjectRoleRequest,
  DeleteProjectRoleResponse,
} from "@ServerTypes/projects/project.schema";
import type { SaveDefaultSpaceRequest, SaveDefaultSpaceResponse } from "@ServerTypes/spaces/space.schema";
import {
  setProjectRolesList,
  setEntityListAction as setEntityList,
  setCategoryListAction as setCategoryList,
  setStatusData,
  deletedSpaceStatus,
  getProjectSettingObjectAction as getProjectSettingObject,
} from "../reducers/projectSetting";

export async function addProjectRole(data: AddProjectRoleRequest): Promise<AddProjectRoleResponse> {
  const response = await axiosWrapper.post(`${getBackendUrl()}/projects/addProjectRole`, data);
  return response.data;
}

export async function deleteProjectRole(data: DeleteProjectRoleRequest): Promise<DeleteProjectRoleResponse> {
  const response = await axiosWrapper.post(`${getBackendUrl()}/projects/deleteProjectRole`, data);
  return response.data;
}

// updateProjectRolePermission
export function updateProjectRolePermission(data: any) {
  return () => {
    axiosWrapper.post(`${getBackendUrl()}/projects/changeProjectRolePermission`, data);
  };
}

export function getProjectRoles(data: any) {
  return (dispatch: any) => {
    let projectId = data?.projectId;
    if (!projectId) {
      const pathArray = location.pathname.split("/");
      projectId = pathArray[pathArray.length - 2];
    }
    axiosWrapper
      .post(`${getBackendUrl()}/projects/getProjectRoles`, {
        id: projectId,
      })
      .then((response: any) => {
        if (response.data.status) {
          dispatch(setProjectRolesList(response.data.data));
        }
      });
  };
}

export function saveProjectRole(data: any, toastdata: any) {
  return (dispatch: any) => {
    axiosWrapper.post(`${getBackendUrl()}/projects/changeUserRoleFromProject/`, data).then((response: any) => {
      if (response.data.status) {
        dispatch(
          showToastNotification({
            content: t("{{user}}'s role has been changed to {{role}}", {
              user: toastdata.selectedUserfromRow,
              role: toastdata.roleChangedTo,
            }),
            type: TOAST_TYPE_SUCCESS,
          }),
        );
      } else {
        dispatch(
          showToastNotification({
            content: untranslated(response.data.errorMessage),
            type: TOAST_TYPE_ERROR,
          }),
        );
      }
    });
  };
}
// updateStatusSpaces
export function updateStatusSpaces(data: any) {
  return () => {
    axiosWrapper.post(`${getBackendUrl()}/status/editVisibleData`, data);
  };
}
// getAllEntity
export function getAllEntity() {
  return (dispatch: any) => {
    axiosWrapper.get(`${getBackendUrl()}/status/getEntityList`).then((response: any) => {
      if (response.data.status) {
        dispatch(setEntityList(response.data.data));
      }
    });
  };
}
// addStatusToProject
export function addStatusToProject(data: any) {
  return () => {
    axiosWrapper.post(`${getBackendUrl()}/status/saveStatusData`, data);
  };
}
// getStatusData
export function getStatusData(data: any) {
  return (dispatch: any) => {
    axiosWrapper.post(`${getBackendUrl()}/status/getStatusData`, data).then((response: any) => {
      if (response.data.status) {
        dispatch(setStatusData(response.data.data));
      }
    });
  };
}
// getAllCategories
export function getAllCategories() {
  return (dispatch: any) => {
    axiosWrapper.get(`${getBackendUrl()}/status/getCategoryData`).then((response: any) => {
      if (response.data.status) {
        dispatch(setCategoryList(response.data.data));
      }
    });
  };
}
// get list of user which are added into project

// export function deleteSpace(data) {
//   return async (dispatch: any) => {
//     const response = await axiosWrapper.post(
//       `${getBackendUrl()}/spaces/deleteSpacesData`,
//       data
//     );

//     dispatch(deletedSpaceStatus(response.data.data));
//     return response.data.data.status;
//   };
// }

// delete space from project
export function deleteSpace(data: any) {
  return (dispatch: any) => {
    axiosWrapper
      .post(`${getBackendUrl()}/spaces/spacesData`, {
        action: "remove",
        key: { spaceId: data.spaceId },
      })
      .then((response: any) => {
        dispatch(deletedSpaceStatus(response.data.data));
      });
  };
}

// Delete User from a project

export async function removeUsersFromSingleProject(data: any) {
  const response = await axiosWrapper.post(`${getBackendUrl()}/projects/removeUsersFromSingleProject/`, data);
  return response.data;
}

export function getProjectObject(data: any) {
  if (data.id) {
    return (dispatch: any) => {
      axiosWrapper
        .get(`${getBackendUrl()}/projects/getProjectObject/${data.id}`)
        .then((res: any) => {
          if (res.data.status) {
            dispatch(getProjectSettingObject(res.data.data));
          }
        })
        .catch((err: any) => console.log("Error in project setting object ", err));
    };
  }
}
export const teamsController = async (data: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/projects/teamsController`, data);
  return response;
};
export const locationController = async (data: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/projects/locationController`, data);
  return response;
};
export const projectTemplateConfigHandler = async (data: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/forms/projectTemplateConfigHandler`, data);
  return response;
};
export const WBSController = async (data: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/projects/WBSController`, data);
  return response;
};
export const saveDefaultSpace = async (data: SaveDefaultSpaceRequest): Promise<{ data: SaveDefaultSpaceResponse }> => {
  return await axiosWrapper.post<SaveDefaultSpaceResponse>(`${getBackendUrl()}/spaces/saveDefaultSpace`, data);
};
